"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wixSdk = void 0;
var tslib_1 = require("tslib");
var utils_1 = require("./utils");
function wixSdk(Wix) {
    var errorLogger = function (ex) {
        if (global.console && typeof global.console.error === 'function') {
            console.error(ex); //tslint:disable-line:no-console
        }
    };
    if (!Wix) {
        errorLogger(new Error('Wix Sdk is missing'));
        return null;
    }
    var safeCall = utils_1.createSafeCall(function (ex) {
        errorLogger(ex);
    });
    var WixSdkWrapper = {
        valid: false,
        config: {
            setErrorLogger: function (handler) {
                errorLogger = handler;
            },
        },
        Activities: {
            Type: Wix.Activities.Type,
            Error: Wix.Activities.Error,
            postActivity: function (activity) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Activities.postActivity(activity, resolve, reject);
                }));
            },
            getActivities: function (query) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Activities.getActivities(resolve, reject, query);
                }));
            },
            getActivityById: function (id) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Activities.getActivityById(id, resolve, reject);
                }));
            },
            getUserSessionToken: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Activities.getUserSessionToken(resolve);
                }));
            },
        },
        Analytics: {
            PixelType: Wix.Analytics.PixelType,
            PixelEventType: Wix.Analytics.PixelEventType,
            registerCampaignPixel: Wix.Analytics.registerCampaignPixel,
            reportCampaignEvent: Wix.Analytics.reportCampaignEvent,
        },
        Billing: {
            Cycle: Wix.Billing.Cycle,
            openBillingPageForProduct: function (vendorProductId, cycle) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Billing.openBillingPageForProduct(vendorProductId, cycle, reject);
                }));
            },
            getBillingPageForProduct: function (vendorProductId, cycle) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Billing.getBillingPageForProduct(vendorProductId, cycle, resolve, reject);
                }));
            },
            getBillingPackages: function (vendorProductIds) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Billing.getBillingPackages(vendorProductIds, resolve, reject);
                }));
            },
            getProducts: function (options) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Billing.getProducts(options, resolve, reject);
                }));
            },
        },
        Contacts: {
            getContacts: function (options) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Contacts.getContacts(options, resolve, reject);
                }));
            },
            getContactById: function (id) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Contacts.getContactById(id, resolve, reject);
                }));
            },
            reconcileContact: function (contactInfo) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Contacts.reconcileContact(contactInfo, resolve, reject);
                }));
            },
        },
        Dashboard: {
            PremiumIntent: Wix.Dashboard.PremiumIntent,
            setHeight: Wix.Dashboard.setHeight,
            openMediaDialog: function (mediaType, multipleSelection, onCancel) {
                return new Promise(function (resolve) {
                    Wix.Dashboard.openMediaDialog(mediaType, multipleSelection, resolve, onCancel);
                });
            },
            openBillingPage: Wix.Dashboard.openBillingPage,
            openModal: function (url, width, height) {
                return new Promise(function (resolve) {
                    Wix.Dashboard.openModal(url, width, height, resolve);
                });
            },
            closeWindow: Wix.Dashboard.closeWindow,
            scrollTo: Wix.Dashboard.scrollTo,
            getEditorUrl: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Dashboard.getEditorUrl(resolve);
                }));
            },
            pushState: Wix.Dashboard.pushState,
            resizeWindow: Wix.Dashboard.resizeWindow,
            revalidateSession: function () {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Dashboard.revalidateSession(resolve, reject);
                }));
            },
            getProducts: function () {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Dashboard.getProducts(resolve, reject);
                }));
            },
            getSiteViewUrl: function (options) {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Dashboard.getSiteViewUrl(options, resolve);
                }));
            },
            appEngaged: Wix.Dashboard.appEngaged,
        },
        Error: Wix.Error,
        Events: Wix.Events,
        Features: {
            Types: Wix.Features.Types,
            isSupported: function (featureName) {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Features.isSupported(featureName, resolve);
                }));
            },
        },
        Media: {
            AudioType: Wix.Media.AudioType,
            getImageUrl: Wix.Media.getImageUrl,
            getResizedImageUrl: Wix.Media.getResizedImageUrl,
            getAudioUrl: Wix.Media.getAudioUrl,
            getDocumentUrl: Wix.Media.getDocumentUrl,
            getSwfUrl: Wix.Media.getSwfUrl,
            getPreviewSecureMusicUrl: Wix.Media.getPreviewSecureMusicUrl,
        },
        PubSub: {
            unsubscribe: Wix.PubSub.unsubscribe,
            subscribe: Wix.PubSub.subscribe,
            publish: Wix.PubSub.publish,
        },
        Preview: {
            openSettingsDialog: Wix.Preview.openSettingsDialog,
        },
        Settings: {
            MediaType: Wix.Settings.MediaType,
            PremiumIntent: Wix.Settings.PremiumIntent,
            getColorByreference: Wix.Settings.getColorByreference,
            setBooleanParam: Wix.Settings.setBooleanParam,
            setColorParam: Wix.Settings.setColorParam,
            setNumberParam: Wix.Settings.setNumberParam,
            getSiteColors: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Settings.getSiteColors(resolve);
                }));
            },
            getStyleColorByKey: Wix.Settings.getStyleColorByKey,
            getWindowPlacement: function (compId) {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Settings.getWindowPlacement(compId, resolve);
                }));
            },
            getDashboardAppUrl: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Settings.getDashboardAppUrl(resolve);
                }));
            },
            getSiteInfo: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Settings.getSiteInfo(resolve);
                }));
            },
            getSitePages: function (options) {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Settings.getSitePages(options, resolve);
                }));
            },
            getSiteMap: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Settings.getSiteMap(resolve);
                }));
            },
            getStyleParams: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Settings.getStyleParams(resolve);
                }));
            },
            openBillingPage: Wix.Settings.openBillingPage,
            appEngaged: Wix.Settings.appEngaged,
            openMediaDialog: function (mediaType, multipleSelection, onCancel) {
                return new Promise(function (resolve) {
                    Wix.Settings.openMediaDialog(mediaType, multipleSelection, resolve, onCancel);
                });
            },
            openSiteMembersSettingsDialog: Wix.Settings.openSiteMembersSettingsDialog,
            refreshApp: Wix.Settings.refreshApp,
            refreshAppByCompIds: Wix.Settings.refreshAppByCompIds,
            setWindowPlacement: Wix.Settings.setWindowPlacement,
            triggerSettingsUpdatedEvent: Wix.Settings.triggerSettingsUpdatedEvent,
            openModal: function (url, width, height, title, bareUI) {
                return new Promise(function (resolve) {
                    Wix.Settings.openModal(url, width, height, title, resolve, bareUI);
                });
            },
            closeWindow: Wix.Settings.closeWindow,
            addComponent: function (options) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Settings.addComponent(options, resolve, reject);
                }));
            },
            resizeComponent: function (options) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Settings.resizeComponent(options, resolve, reject);
                }));
            },
            setExternalId: function (guid) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Settings.setExternalId(guid, resolve, reject);
                }));
            },
            revalidateSession: function () {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Settings.revalidateSession(resolve, reject);
                }));
            },
            getCurrentPageAnchors: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Settings.getCurrentPageAnchors(resolve);
                }));
            },
            setFullWidth: function (shouldBeFullWidth, options) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Settings.setFullWidth(shouldBeFullWidth, options, resolve, reject);
                }));
            },
            isFullWidth: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Settings.isFullWidth(resolve);
                }));
            },
            openReviewInfo: Wix.Settings.openReviewInfo,
            getStateUrl: function (sectionId, state) {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Settings.getStateUrl(sectionId, state, resolve);
                }));
            },
            isComponentInstalled: function (componentId) {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Settings.isComponentInstalled(componentId, resolve);
                }));
            },
            openLinkPanel: function (options, onCacnel) {
                return new Promise(function (resolve) {
                    Wix.Settings.openLinkPanel(options, resolve, onCacnel);
                });
            },
        },
        Styles: {
            getStyleParams: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Styles.getStyleParams(resolve);
                }));
            },
            setStyleParams: function (styleObjArr) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Styles.setStyleParams(styleObjArr, resolve, reject);
                }));
            },
            setFontParam: function (key, value) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Styles.setFontParam(key, value, resolve, reject);
                }));
            },
            getEditorFonts: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Styles.getEditorFonts(resolve);
                }));
            },
            getSiteTextPresets: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Styles.getSiteTextPresets(resolve);
                }));
            },
            getFontsSpriteUrl: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Styles.getFontsSpriteUrl(resolve);
                }));
            },
            getStyleFontByKey: Wix.Styles.getStyleFontByKey,
            getStyleFontByReference: Wix.Styles.getStyleFontByReference,
            getSiteColors: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Styles.getSiteColors(resolve);
                }));
            },
            getStyleColorByKey: Wix.Styles.getStyleColorByKey,
            getColorByreference: Wix.Styles.getColorByreference,
            setColorParam: function (key, value) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Styles.setColorParam(key, value, resolve, reject);
                }));
            },
            setNumberParam: function (key, value) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Styles.setNumberParam(key, value, resolve, reject);
                }));
            },
            setBooleanParam: function (key, value) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Styles.setBooleanParam(key, value, resolve, reject);
                }));
            },
            openColorPicker: function (params) {
                return new Promise(function (resolve) {
                    Wix.Styles.openColorPicker(params, resolve);
                });
            },
            openFontPicker: function (params) {
                return new Promise(function (resolve) {
                    Wix.Styles.openFontPicker(params, resolve);
                });
            },
            setUILIBParamValue: Wix.Styles.setUILIBParamValue,
            getStyleId: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Styles.getStyleId(resolve);
                }));
            },
            getStyleParamsByStyleId: function (styleId) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Styles.getStyleParamsByStyleId(styleId, resolve, reject);
                }));
            },
        },
        Theme: Wix.Theme,
        Utils: {
            getViewMode: safeCall(Wix.Utils.getViewMode),
            toWixDate: safeCall(Wix.Utils.toWixDate),
            getCompId: safeCall(Wix.Utils.getCompId),
            getOrigCompId: safeCall(Wix.Utils.getOrigCompId),
            getWidth: safeCall(Wix.Utils.getWidth),
            getLocale: safeCall(Wix.Utils.getLocale),
            getCacheKiller: safeCall(Wix.Utils.getCacheKiller),
            getTarget: safeCall(Wix.Utils.getTarget),
            getSectionUrl: function (sectionIdentifier) {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Utils.getSectionUrl(sectionIdentifier, resolve);
                }));
            },
            getInstanceId: safeCall(Wix.Utils.getInstanceId),
            getSignDate: safeCall(Wix.Utils.getSignDate),
            getUid: safeCall(Wix.Utils.getUid),
            getPermissions: safeCall(Wix.Utils.getPermissions),
            getIpAndPort: safeCall(Wix.Utils.getIpAndPort),
            getDemoMode: safeCall(Wix.Utils.getDemoMode),
            getDeviceType: safeCall(Wix.Utils.getDeviceType),
            getInstanceValue: safeCall(Wix.Utils.getInstanceValue),
            navigateToSection: safeCall(Wix.Utils.navigateToSection),
            getSiteOwnerId: safeCall(Wix.Utils.getSiteOwnerId),
            Media: {
                AudioType: Wix.Utils.Media.AudioType,
                getImageUrl: Wix.Utils.Media.getImageUrl,
                getResizedImageUrl: Wix.Utils.Media.getResizedImageUrl,
                getAudioUrl: Wix.Utils.Media.getAudioUrl,
                getDocumentUrl: Wix.Utils.Media.getDocumentUrl,
                getSwfUrl: Wix.Utils.Media.getSwfUrl,
                getPreviewSecureMusicUrl: Wix.Utils.Media.getPreviewSecureMusicUrl,
            },
        },
        Data: {
            SCOPE: Wix.Data.SCOPE,
            Public: {
                set: function (key, value, options) {
                    return utils_1.addTimeout(new Promise(function (resolve, reject) {
                        Wix.Data.Public.set(key, value, options, resolve, reject);
                    }));
                },
                get: function (key, value, options) {
                    return utils_1.addTimeout(new Promise(function (resolve, reject) {
                        Wix.Data.Public.get(key, options, resolve, reject);
                    }));
                },
                remove: function (key, value, options) {
                    return utils_1.addTimeout(new Promise(function (resolve, reject) {
                        Wix.Data.Public.remove(key, options, resolve, reject);
                    }));
                },
            },
        },
        Performance: {
            applicationLoaded: Wix.Performance.applicationLoaded,
            applicationLoadingStep: Wix.Performance.applicationLoadingStep,
        },
        WindowOrigin: Wix.WindowOrigin,
        WindowPlacement: Wix.WindowPlacement,
        openModal: function (url, width, height, theme) {
            return new Promise(function (resolve) {
                Wix.openModal(url, width, height, resolve, theme);
            });
        },
        openPopup: function (url, width, height, position, theme) {
            return new Promise(function (resolve) {
                Wix.openPopup(url, width, height, position, resolve, theme);
            });
        },
        setHeight: Wix.setHeight,
        closeWindow: Wix.closeWindow,
        scrollTo: Wix.scrollTo,
        scrollBy: Wix.scrollBy,
        getSiteInfo: function () {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.getSiteInfo(resolve);
            }));
        },
        getSitePages: function (options) {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.getSitePages(options, resolve);
            }));
        },
        getSiteMap: function () {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.getSiteMap(resolve);
            }));
        },
        getBoundingRectAndOffsets: function () {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.getBoundingRectAndOffsets(resolve);
            }));
        },
        removeEventListener: Wix.removeEventListener,
        addEventListener: Wix.addEventListener,
        resizeWindow: Wix.resizeWindow,
        requestLogin: function (options, onCancel) {
            return new Promise(function (resolve) {
                Wix.requestLogin(options, resolve, onCancel);
            });
        },
        logOutCurrentMember: function (options) {
            return utils_1.addTimeout(new Promise(function (resolve, reject) {
                Wix.logOutCurrentMember(options, reject);
            }));
        },
        currentMember: function () {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.currentMember(resolve);
            }));
        },
        navigateTo: function (linkData) {
            return utils_1.addTimeout(new Promise(function (resolve, reject) {
                Wix.navigateTo(linkData, reject);
            }));
        },
        navigateToPage: function (pageId, options) {
            return utils_1.addTimeout(new Promise(function (resolve, reject) {
                Wix.navigateToPage(pageId, options, reject);
            }));
        },
        getCurrentPageId: function () {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.getCurrentPageId(resolve);
            }));
        },
        pushState: Wix.pushState,
        reportHeightChange: Wix.reportHeightChange,
        getStyleParams: function () {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.getStyleParams(resolve);
            }));
        },
        getExternalId: function () {
            return utils_1.addTimeout(new Promise(function (resolve, reject) {
                Wix.getExternalId(resolve, reject);
            }));
        },
        navigateToComponent: function (compId, options) {
            return utils_1.addTimeout(new Promise(function (resolve, reject) {
                Wix.navigateToComponent(compId, options, reject);
            }));
        },
        resizeComponent: function (options) {
            return utils_1.addTimeout(new Promise(function (resolve, reject) {
                Wix.resizeComponent(options, resolve, reject);
            }));
        },
        revalidateSession: function () {
            return utils_1.addTimeout(new Promise(function (resolve, reject) {
                Wix.revalidateSession(resolve, reject);
            }));
        },
        getCurrentPageAnchors: function () {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.getCurrentPageAnchors(resolve);
            }));
        },
        navigateToAnchor: function (anchorId) {
            return utils_1.addTimeout(new Promise(function (resolve, reject) {
                Wix.navigateToAnchor(anchorId, reject);
            }));
        },
        getComponentInfo: function () {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.getComponentInfo(resolve);
            }));
        },
        replaceSectionState: Wix.replaceSectionState,
        setPageMetadata: Wix.setPageMetadata,
        getStateUrl: function (sectionId, state) {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.getStateUrl(sectionId, state, resolve);
            }));
        },
        getAdsOnPage: function () {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.getAdsOnPage(resolve);
            }));
        },
    };
    if (!Wix.SuperApps) {
        return WixSdkWrapper;
    }
    return tslib_1.__assign(tslib_1.__assign({}, WixSdkWrapper), { SuperApps: {
            Settings: {
                MediaType: Wix.SuperApps.Settings.MediaType,
                openBillingPage: Wix.SuperApps.Settings.openBillingPage,
                getInstalledInstance: function (appDefinitionId) {
                    return utils_1.addTimeout(new Promise(function (resolve, reject) {
                        Wix.SuperApps.Settings.getInstalledInstance(appDefinitionId, resolve, reject);
                    }));
                },
                openMediaDialog: function (mediaType, multipleSelection, onCancel) {
                    return new Promise(function (resolve) {
                        Wix.SuperApps.Settings.openMediaDialog(mediaType, multipleSelection, resolve, onCancel);
                    });
                },
                openModal: function (url, width, height, title, bareUI, options) {
                    return new Promise(function (resolve) {
                        Wix.SuperApps.Settings.openModal(url, width, height, title, resolve, bareUI, options);
                    });
                },
                setHelpArticle: Wix.SuperApps.Settings.setHelpArticle,
            },
            Dashboard: {
                showHeader: Wix.SuperApps.Dashboard.showHeader,
                hideHeader: Wix.SuperApps.Dashboard.hideHeader,
                setHelpArticle: Wix.SuperApps.Dashboard.setHelpArticle,
                getProducts: function (options) {
                    return utils_1.addTimeout(new Promise(function (resolve, reject) {
                        Wix.SuperApps.Dashboard.getProducts(options, resolve, reject);
                    }));
                },
                openMediaDialog: function (mediaType, multipleSelection, onCancel) {
                    return new Promise(function (resolve) {
                        Wix.SuperApps.Dashboard.openMediaDialog(mediaType, multipleSelection, resolve, onCancel);
                    });
                },
            },
            getInstalledInstance: function (appDefinitionId) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.SuperApps.getInstalledInstance(appDefinitionId, resolve, reject);
                }));
            },
            OnBoarding: {
                Settings: {
                    getStyleByCompId: function (compId) {
                        return utils_1.addTimeout(new Promise(function (resolve) {
                            Wix.SuperApps.OnBoarding.Settings.getStyleByCompId(compId, resolve);
                        }));
                    },
                },
            },
            Billing: {
                getProducts: function (options) {
                    return utils_1.addTimeout(new Promise(function (resolve, reject) {
                        Wix.SuperApps.Billing.getProducts(options, resolve, reject);
                    }));
                },
            },
            getCtToken: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.SuperApps.getCtToken(resolve);
                }));
            },
        }, getInstalledInstance: function (appDefinitionId) {
            return utils_1.addTimeout(new Promise(function (resolve, reject) {
                Wix.getInstalledInstance(appDefinitionId, resolve, reject);
            }));
        }, OnBoarding: {
            Settings: {
                getStyleByCompId: function (compId) {
                    return utils_1.addTimeout(new Promise(function (resolve) {
                        Wix.OnBoarding.Settings.getStyleByCompId(compId, resolve);
                    }));
                },
            },
        }, getCtToken: function () {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.getCtToken(resolve);
            }));
        } });
}
exports.wixSdk = wixSdk;
//# sourceMappingURL=create-wix-sdk-wrapper.js.map